import React from 'react';

import CTAButton from 'components/CTAButton';
import { ContainerConstants } from 'lib/Constants';
import NavActions from 'lib/NavActions';
import BuyCardImage from '../../../../assets/images/Buy.webp';
import SubmitCardImage from '../../../../assets/images/Submit.webp';
import CollectCardImage from '../../../../assets/images/Collect.webp';

import HowToJoinSectionStyles from './_HowToJoinSectionStyles.module.scss';

const {
    homePage: {
        howToJoinContainerId,
    },
} = ContainerConstants;

const HowToJoinSection = (): JSX.Element => {
    const {
        navToLogin,
    } = NavActions;

    return (
        <div
            id={howToJoinContainerId}
            className={HowToJoinSectionStyles.container}
        >
            <h2>
                How To Join
            </h2>

            <div className={HowToJoinSectionStyles['card-container']}>
                <div className={HowToJoinSectionStyles.card}>
                    <picture>
                        <img
                            src={BuyCardImage}
                            alt='CooperVision Rewards Program'
                            className={HowToJoinSectionStyles['card-image-buy']}
                        />
                    </picture>
                    <div className={HowToJoinSectionStyles['card-numbering']}>
                        <h3>1.</h3>
                        <h3 className={HowToJoinSectionStyles['card-title']}>BUY</h3>
                    </div>

                    <p>
                        <span className={HowToJoinSectionStyles['highlighted-word']}>Biofinity® </span>
                        or
                        <span className={HowToJoinSectionStyles['highlighted-word']}>
                            &nbsp;MyDay® range of products
                        </span>
                        <span className={HowToJoinSectionStyles['highlighted-word-symbol']}>^ </span>
                        in the specified
                        <br />
                        quantity in a single receipt.
                    </p>
                </div>

                <div className={HowToJoinSectionStyles.card}>
                    <picture>
                        <img
                            src={SubmitCardImage}
                            alt='CooperVision Rewards Program'
                            className={HowToJoinSectionStyles['card-image-submit']}
                        />
                    </picture>
                    <div className={HowToJoinSectionStyles['card-numbering']}>
                        <h3>2.</h3>
                        <h3 className={HowToJoinSectionStyles['card-title']}>SUBMIT</h3>
                    </div>
                    <p>
                        your purchase details &
                        <br />
                        a clear receipt phot by
                        <br />
                        <span className={HowToJoinSectionStyles['highlighted-word']}> logging in  </span>
                        or
                        <span className={HowToJoinSectionStyles['highlighted-word']}> sign up </span>
                        <br />
                        if it is your first time.
                    </p>
                </div>

                <div className={HowToJoinSectionStyles.card}>
                    <picture>
                        <img
                            src={CollectCardImage}
                            alt='CooperVision Rewards Program'
                            className={HowToJoinSectionStyles['card-image-collect']}
                        />
                    </picture>
                    <div className={HowToJoinSectionStyles['card-numbering']}>
                        <h3>3.</h3>
                        <h3 className={HowToJoinSectionStyles['card-title']}>COLLECT</h3>
                    </div>

                    <p>
                        and redeem exclusive
                        <br />
                        vouchers! Enjoy
                        <br />
                        before it expires.
                    </p>
                </div>
            </div>

            <CTAButton
                label='Sign Up Now'
                onClick={navToLogin}
                className={HowToJoinSectionStyles['terms-button']}
            />
        </div>
    );
};

export default HowToJoinSection;
